import api from "./apiConfig";

export const CREATE_JUICIO = async (data) => {
	try {
		const response = await api.post("/taxTrial", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_JUICIO_BY_CASO = async (id) => {
	try {
		const response = await api.get(`/taxTrialByTaxMatterId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_JUICIO = async (id, data) => {
	try {
		const response = await api.put(`/taxTrial/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};